
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"16","viewBox":"0 0 24 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M1.381 6.423l-.363-1.786a.872.872 0 01.851-1.044h4.073c.413 0 .769.29.852.696l.42 2.064.064.32h1.836c.271 0 .523.138.67.366l.53.83 1.612-.468c.145-.157.317-.32.51-.48a8.754 8.754 0 011.829-1.164 4.634 4.634 0 011.002-.351l1.486 1.742.202-.172-1.378-1.616h.003l-.427-.568-.204-.272-.155-.087-.886-.499a.266.266 0 11.262-.463l.899.506.19.108a.27.27 0 01.083.072l.014.018.836-.522.057-1.724a.094.094 0 01.09-.09.09.09 0 01.06.016l3.59 2.599c.274.198.407.539.34.87L20 6.967l-.017.086-.601.588.204.591A3.24 3.24 0 0123 11.02l-6.33 1.282a3.22 3.22 0 01-.091-.478h-.536l.795-1.891-.246-.104-.838 1.994h-.598l.794-1.89-.245-.104-.838 1.994H1.483s.119-1.538.929-2.662h5.302v-.242h-5.11c.146-.168.31-.323.497-.454l-.068-.339-.103-.514h2.6l-.059-.266h-2.96c-.548 0-1.02-.386-1.13-.923zm18.355.495l.332-1.647a.6.6 0 00-.236-.603l-.56-.404-.168.048a.31.31 0 00-.225.327l.158 1.679.7.6zm.057 6.237a1.697 1.697 0 01-1.476-.862l-1.02.207a2.704 2.704 0 005.2-1.042v-.011l-1.018.206a1.699 1.699 0 01-1.686 1.502zM9.408 12.142h5.828v.42H9.408v-.42zm-5.673 0a1.7 1.7 0 001.553 1.013c.692 0 1.288-.416 1.552-1.012h1.064a2.705 2.705 0 01-5.232 0h1.063z","fill":"currentColor"}})])
          )
        }
      }
    